import type { CSSProperties } from 'react';

export const MIN_WIDTH_PCT = 30;
export const MAX_WIDTH_PCT = 100;
export const SNAP_PCTS = [50, 75, 100];
const SNAP_THRESHOLD = 2;

export const clampWidthPct = (pct: number): number =>
    Math.min(MAX_WIDTH_PCT, Math.max(MIN_WIDTH_PCT, pct));

export const snapWidthPct = (pct: number): number => {
    for (const snap of SNAP_PCTS) {
        if (Math.abs(pct - snap) <= SNAP_THRESHOLD) return snap;
    }
    return pct;
};

/**
 * Box for a chart block. Unsized blocks keep the legacy fixed-height box
 * (chart contain-fits inside, full column width) so existing reports render
 * pixel-identical; a user-chosen width switches to an aspect-driven, centered
 * box that matches how the .docx scales the embedded SVG.
 */
export const chartBoxStyle = (
    widthPct: number | undefined,
    canvas: { width: number; height: number },
): { className: string; style?: CSSProperties } =>
    widthPct === undefined
        ? { className: 'h-[340px]' }
        : {
              className: '',
              style: {
                  width: `${widthPct}%`,
                  aspectRatio: `${canvas.width} / ${canvas.height}`,
                  marginInline: 'auto',
              },
          };
